@if (!isMobile) {
  <app-engagements-table
    [dataSource]="dataSource"
    [displayedColumns]="displayedColumns()"
    [highlightTerm]="highlightTerm()"
    [listStatus]="listStatus()"
    [paginationOptions]="(paginationOptions$ | async)"
    [searchControl]="searchControl"
    [sortActive]="activeSortColumn"
    [sortDirection]="activeSortDirection"
    (rowClick)="viewEngagement($event)"
    (pageChange)="onPageChange($event)"
    (sortChange)="onSortChange($event)"
  />
} @else {
  <app-engagements-card-list
    [engagements]="engagements()"
    [listStatus]="listStatus()"
    [paginationOptions]="(paginationOptions$ | async)"
    [searchControl]="searchControl"
    (cardClick)="viewEngagement($event)"
    (pageChange)="onPageChange($event)"
  />
}
